import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { AlertObject } from '.';

/**
 * GLOBAL MIXIN
 * this code is injected into every component in the application and is designed to be used with AlertProvider
 *
 * examples:
 * this.$alert.show('save', {type: 'success', messages: ['success message]})
 * this.$alert.hide('save')
 *
 * NOTE: if this becomes a performance issue this should be manually added to any component that will throw errors instead of a global mixin
 *  currently this is added to literally everything, even buttons/lists
 *
 * possible improvements:
 *  -allow the uuid to be optionally passed in so an alert can be shared accross multiple components (for example tabs)
 *      example being a parent (tab) passes a uuid to each tab contents and the alert should only clear when the entire tab structure unmounts
 *
 */
Vue.mixin(
  mixins().extend({
    inject: {
      alert_providershow: {
        from: 'alert_providershow',
        default: undefined,
      },
      alert_providerhide: {
        from: 'alert_providerhide',
        default: undefined,
      },
    },
    computed: {
      $alert(): {
        show: (key: string, alert: AlertObject) => void;
        hide: (key: string) => void;
      } {
        return {
          show: this.alert_mixinshow,
          hide: this.alert_mixinhide,
        };
      },
    },
    destroyed() {
      // hide every alert caused by the component when it unmounts
      if (typeof (this as any).alert_providerhide === 'function') {
        this.alert_mixinhide(''); // blank key will match all alerts for this component ('${uuid}_')
      }
    },
    methods: {
      alert_mixinshow(key: string, alert: AlertObject) {
        (this as any).alert_providershow(`${this.$uuid}_${key}`, alert);
      },
      alert_mixinhide(key: string) {
        (this as any).alert_providerhide(`${this.$uuid}_${key}`);
      },
    },
  })
);
